/** @ngInject */
export function credentialsConfig($stateProvider) {
  $stateProvider.state('logout', {
    url: '/logout',
    controller: 'LogoutCtrl',
    data: {},
  })
}
